var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3125 3.71875C5.3125 3.15516 5.53638 2.61466 5.9349 2.21615C6.33341 1.81763 6.87391 1.59375 7.4375 1.59375H9.5625C10.1261 1.59375 10.6666 1.81763 11.0651 2.21615C11.4636 2.61466 11.6875 3.15516 11.6875 3.71875V3.86396C12.3484 3.92417 13.0029 4.0035 13.6524 4.10054C14.6823 4.25496 15.4062 5.151 15.4062 6.16675V8.31512C15.4062 9.17292 14.8863 9.98112 14.0349 10.2645C12.2498 10.857 10.3809 11.1581 8.5 11.1562C6.56625 11.1562 4.70546 10.8432 2.96508 10.2645C2.11367 9.98112 1.59375 9.17292 1.59375 8.31512V6.16675C1.59375 5.151 2.31767 4.25425 3.34758 4.10054C4.00016 4.00295 4.6554 3.92405 5.3125 3.86396V3.71875ZM10.625 3.71875V3.7825C9.20964 3.69654 7.79036 3.69654 6.375 3.7825V3.71875C6.375 3.43696 6.48694 3.16671 6.6862 2.96745C6.88546 2.76819 7.15571 2.65625 7.4375 2.65625H9.5625C9.84429 2.65625 10.1145 2.76819 10.3138 2.96745C10.5131 3.16671 10.625 3.43696 10.625 3.71875ZM8.5 9.5625C8.6409 9.5625 8.77602 9.50653 8.87565 9.4069C8.97528 9.30727 9.03125 9.17215 9.03125 9.03125C9.03125 8.89035 8.97528 8.75523 8.87565 8.6556C8.77602 8.55597 8.6409 8.5 8.5 8.5C8.3591 8.5 8.22398 8.55597 8.12435 8.6556C8.02472 8.75523 7.96875 8.89035 7.96875 9.03125C7.96875 9.17215 8.02472 9.30727 8.12435 9.4069C8.22398 9.50653 8.3591 9.5625 8.5 9.5625Z",
    fill: "url(#paint0_linear_469_2658)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 13.0332V11.0527C2.28637 11.141 2.45541 11.2145 2.63004 11.2723C4.5232 11.9009 6.50523 12.2204 8.5 12.2187C10.5485 12.2187 12.5233 11.8872 14.37 11.273C14.5485 11.2135 14.717 11.1392 14.875 11.0527V13.0332C14.875 14.0617 14.1334 14.9656 13.0879 15.1037C11.5862 15.3034 10.0548 15.4062 8.5 15.4062C6.96572 15.4065 5.43309 15.3054 3.91212 15.1037C2.86662 14.9656 2.125 14.0617 2.125 13.0332Z",
    fill: "url(#paint1_linear_469_2658)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_469_2658",
    x1: 8.5,
    y1: 1.59375,
    x2: 8.5,
    y2: 11.1563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2FFA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9963"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_469_2658",
    x1: 8.5,
    y1: 11.0527,
    x2: 8.5,
    y2: 15.4062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2FFA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9963"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppoint);
export default __webpack_public_path__ + "static/media/appoint.b6bc4be615e4f02f9640977ecbb69177.svg";
export { ForwardRef as ReactComponent };